export const Footer = (props) => {
  // Determine the correct privacy policy link based on language
  const privacyPolicyUrl = props.currentLanguage === 'et' 
    ? '/privacy-policy?lang=et' 
    : '/privacy-policy?lang=en';
    
  const year = new Date().getFullYear();
  const copyright = props.data
    ? props.data.copyright.replace('2025', year).replace('2026', year)
    : `© ${year} RecycleMore OÜ.`;

  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            {copyright}{' '}
            <a href={privacyPolicyUrl} rel='nofollow'>
              {props.data ? props.data.termsLink : 'Kasutustingimused'}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}